import { render, staticRenderFns } from "./ProfilePagination.vue?vue&type=template&id=28e8671e&scoped=true&"
import script from "./ProfilePagination.vue?vue&type=script&lang=js&"
export * from "./ProfilePagination.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePagination.vue?vue&type=style&index=0&id=28e8671e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8671e",
  null
  
)

export default component.exports